// extracted by mini-css-extract-plugin
export default {"colorIndicators":"btHeeCkxaAI4006jZJEB","colorIndicatorsItem":"a7jPlzcY_IweFPFm9rkG"};